import { render, staticRenderFns } from "./EcommerceDetail.vue?vue&type=template&id=68991ce7&scoped=true"
import script from "./EcommerceDetail.vue?vue&type=script&lang=js"
export * from "./EcommerceDetail.vue?vue&type=script&lang=js"
import style0 from "./EcommerceDetail.vue?vue&type=style&index=0&id=68991ce7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68991ce7",
  null
  
)

export default component.exports